import { connect } from 'react-redux';
import { compose, withProps } from 'recompose';

import WithToggle from '../../hoc/WithToggle';
import WithBookNoPayQuery from '../../hoc/WithBookNoPayQuery';
import { getIsChopMurrayHillShop, getIsSquireFeeShop, getNoExtrasForReserveNoPay } from '../../shops/selectors';
import withRouteParameters from './withRouteParameters';
import WithTimeWaitingList from '../../hoc/WithTimeWaitingList';
import WithApplePayQuery from '../../hoc/WithApplePayQuery';

export default compose(
  WithApplePayQuery,
  withRouteParameters,
  WithToggle,
  WithBookNoPayQuery,
  WithTimeWaitingList,
  connect(
    (state, ownProps) => ({
      isSquireFeeShop: getIsSquireFeeShop(state, ownProps.shopRoute),
      isChopMurrayHillShop: getIsChopMurrayHillShop(state, ownProps.shopRoute),
      noExtrasForReserveNoPay: getNoExtrasForReserveNoPay(state, ownProps.shopRoute),
    })
  ),
  withProps((props) => {
    const shouldShowTipForWaitingList = !!props.timeWaitingList && !!props.activeTip;
    const shouldShowApplePayTip = !!props.withApplePay && !!props.activeTip;
    const shouldShowTipForBooking = !props.noExtrasForReserveNoPay && !props.bookNoPayQuery && !!props.activeTip;
    return {
      shouldShowTip: shouldShowTipForBooking || shouldShowTipForWaitingList || shouldShowApplePayTip,
    };
  }),
);



// WEBPACK FOOTER //
// ./src/app/reservation/containers/OrderInformationSharedContainer.js